//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { store } from "./store"

import PanelHome from './PanelHome.vue';
import PanelFilter from './PanelFilter.vue';
import PanelDetail from './PanelDetail.vue';

export default {
  name: 'AppNav',   
  components: {
    PanelHome,
    PanelFilter,
    PanelDetail,
  },
  data() {
    return {
      tabs: [{ name: 'Home' }, { name: 'Filter' }],
      currentTab: { name: 'Home' },
      panelsVisible: 1,
      panelDetailVisible: store.getDetailPanelValue('visible'),
      
    }
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/AppNav.vue